import React, { Component } from 'react'
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react'

export class MapContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <Map
        google={this.props.google}
        zoom={11}
        className="map"
        initialCenter={{
            lat: 55.437431,
            lng: -4.268314,
        }}>
        <Marker
            title='Kelloholm'
            name='Kelloholm'
            position={{
                lat: 55.3791492,
                lng: -3.9920041,
            }}
        />
        <Marker
            title='Ayr'
            name='Ayr'
            position={{
                lat: 55.457054,
                lng: -4.630043,
            }}
        />
        <Marker
            title='Cumnock'
            name='Cumnock'
            position={{
                lat: 55.4521621,
                lng: -4.2740314,
            }}
        />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAGRfCTRFc0Ja3QMthjyPtWEcHiCl8LJ3M'
})(MapContainer)


// WEBPACK FOOTER //
// ./src/components/Map.jsx